import gql from 'graphql-tag'
import { gqlast } from '../graphqlParser'
/* Función para crear una afiliación */
const CREATE_AFFILIATION = (order) => {
    let newAffiliation = {
        affiliateId: order.affiliateId,
        tier: {
            name: order.affiliation.plan.tier.name,
            amount: order.affiliation.plan.tier.amount,
            interval: order.affiliation.plan.tier.interval,
            externalId: order.affiliation.plan.tier.externalId
        },
        billingInformation: order.billingInformation ? order.billingInformation : undefined,
        planId: order.planId,
        paymentInformation: {
            ...order.buyer,
            paymentType: formatPaymentType(order.paymentInformation.paymentType),
            paymentMethod: order.subscriptionPaymentMethod ? order.subscriptionPaymentMethod : ""
        },
        affiliateData: order.affiliateData,
        savePaymentMethod: order.subscription,
        total: order.total
    }
    const newMutation = gqlast`mutation {
        createAffiliation(data:${newAffiliation}) {
            id
        }
    }`
    return gql`${newMutation}`
}

/* Función para migrar afiliados (SOLO FUNCIONA EN ADMIN)*/
/*
    dataAffiliates.planId = Id del plan al que se le van a agregar los afiliados
    dataAffiliates.tier = Nivel que se le va a poner a cada afiliado
    dataAffiliates.affiliatesData = Arreglo de objetos de afiliados
 */
const MIGRATE_AFILIATES = (dataAffiliates) => {
    let newDataAffiliates = {
      planId: dataAffiliates.planId,
      tier: dataAffiliates.tier,
      affiliatesData: dataAffiliates.affiliatesData
    }
    const newMutation = gqlast`mutation {
      migrateAffiliates(data:${newDataAffiliates}) {
          status
          planId
      }
  }`
  return gql`${newMutation}`
  }

  /* Función para formatear los métodos de pago */
const formatPaymentType = (paymentType) => {
    let newPaymentType = ""
    switch (paymentType) {
        case "Tarjeta de crédito o débito":
            newPaymentType = "CARD"
            break;
        case "SPEI":
            newPaymentType = "BANK_TRANSFER"
            break;
        case "Pago en OXXO":
            newPaymentType = "CASH"
            break;
        case "PayPal":
            newPaymentType = "PAYPAL"
            break;
        default:
            break;
    }
    return newPaymentType
}
export { CREATE_AFFILIATION, MIGRATE_AFILIATES }
